import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { OrgApp } from './OrgApp.jsx';

// Globally intercept all input events to fix leading zeros in number inputs
document.addEventListener('input', (e) => {
  if (e.target && e.target.type === 'number') {
    const val = e.target.value;
    // Strip leading zeros if followed by another digit (preserves 0 and 0.5)
    const stripped = val.replace(/^(-?)0+(?=\d)/, '$1');
    if (val !== stripped) {
      e.target.value = stripped;
    }
  }
}, true);

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <OrgApp />
  </StrictMode>,
);

